import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUserError } from '../miscUtils';

export const FlexIcon = ({ iconName }: { iconName: string }) => {
  // Icons have following format: "icon-collection:icon-name" e.g. fa:vial
  const iconTokens = iconName.split(':');

  let iconCollection = 'fa'; // the collection we assume in case nothing is provided
  let iconId = iconName;
  if (iconTokens.length == 2) {
    iconCollection = iconTokens[0];
    iconId = iconTokens[1];
  }

  // currently we only have font-awesome icons, this can be extended in the future
  if (iconCollection == 'fa' || iconCollection == 'fas') return <FontAwesomeIcon icon={['fas', iconId as any]} />;
  if (iconCollection == 'fad') return <FontAwesomeIcon icon={['fad', iconId as any]} />;
  throw getUserError(`Invalid icon definition: ${iconName}`);

  // return (
  //     <FontAwesomeIcon icon={iconName as any} />
  // );
};
